import e from "/home/runner/work/oko-web/oko-web/node_modules/hdr.js/dist/hdr.mjs";
//#region src/lib/utils/hdr-image.ts
var t = async (t) => {
	let { width: n, height: r, rgbFloat: i } = await e.load(t);
	return {
		width: n,
		height: r,
		rgbFloat: i
	};
}, n = ({ width: e, height: t, rgbFloat: n }, i) => {
	i.width = e, i.height = t;
	let a = i.getContext("2d");
	if (!a) return;
	let o = a.createImageData(e, t), s = o.data;
	r(n, e, t, s), a.putImageData(o, 0, 0);
}, r = (e, t, n, r) => {
	let i = (e) => (e / (1 + e)) ** (1 / 2.2);
	for (let a = 0; a < t * n; ++a) r[a * 4 + 0] = Math.round(i(e[a * 3 + 0]) * 255), r[a * 4 + 1] = Math.round(i(e[a * 3 + 1]) * 255), r[a * 4 + 2] = Math.round(i(e[a * 3 + 2]) * 255), r[a * 4 + 3] = 255;
};
//#endregion
export { t as loadHdrImage, n as renderHdrImageToCanvas };
